import {parseAdditionalData} from '../../../utilities/helper/parseAdditionalData';
import {formulationTranslations, unitTranslations} from './helpers';

const DetailTable = ({data}: {data: ISubBrand}) => {
  const dataObj = parseAdditionalData(data.additional_data);

  // Using this logic to create entries that only contain values
  const createEntry = ({condition, title, value}: any) =>
    condition ? {title, value} : null;

  const allData = [
    createEntry({
      condition: dataObj.weight && dataObj.weightUnit,
      title: 'وزن بسته‌بندی',
      value: `${dataObj.weight} ${unitTranslations[dataObj.weightUnit!] || ''}`,
    }),
    createEntry({
      condition: dataObj.producingCompany,
      title: 'شرکت تولیدکننده',
      value: dataObj.producingCompany,
    }),
    createEntry({
      condition: data.producing_country?.name,
      title: 'کشور تولیدکننده',
      value: data.producing_country?.name,
    }),
    createEntry({
      condition: dataObj.formulation,
      title: 'فرمولاسیون',
      value:
        formulationTranslations[dataObj.formulation!] || dataObj.formulation,
    }),
    createEntry({
      condition: dataObj.enginePower,
      title: 'قدرت موتور (اسب بخار)',
      value: dataObj.enginePower,
    }),
  ].filter(Boolean); // Filter only fields that are valid

  return (
    <div className="flex flex-col">
      <h5 className="text-md text-gray-700 pr-5 mt-3">مشخصات محصول</h5>

      <div className="sm:mx-0.5 lg:mx-0.5">
        <div className="py-2 inline-block min-w-full">
          <div className="overflow-hidden">
            <table className="w-auto">
              <tbody>
                {allData.map((item, index) => (
                  <TableRow
                    key={item?.value}
                    title={item?.title}
                    value={item?.value}
                    className={index % 2 === 0 ? 'bg-gray-50' : 'bg-white'}
                  />
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailTable;

// ==============================================================================

const TableRow = ({
  title,
  value,
  className,
}: {
  title: string;
  value: number | string;
  className?: string;
}) => {
  return (
    <tr className={` border-b border-t ${className}`}>
      <td className="pr-6 whitespace-nowrap text-md font-medium text-gray-900 w-min pl-7">
        {title}
      </td>
      <td className="text-md text-gray-900 font-light p-3 whitespace-nowrap w-full">
        {value}
      </td>
    </tr>
  );
};
